import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { DSProvider, Modal, Button, Avatar } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import classes from "./ReflectionFeedbackModal.scss";

const ReflectionFeedbackModal = props => {
  const { title, feedback, onClose } = props;

  const { t } = useI18n([]);

  const createdBy = _.get(feedback, "createdBy", {});
  const authorName = getFormattedUserName({ user: createdBy });
  const profileImage = _.get(createdBy, "profileImage", "");
  const label = _.get(feedback, "label", "");

  return (
    <DSProvider dsVersion="2.0">
      <Modal width="486px" height="fit-content" onClose={onClose}>
        <section
          className={classes.container}
          data-test-id="reflectionFeedbackModal-container"
        >
          <Modal.Header isClosable>
            <span
              className="text-heading-6"
              data-test-id="reflectionFeedbackModal-header"
            >
              {title}
            </span>
          </Modal.Header>

          <Modal.Body isScrollable>
            <div className={classes.body}>
              <Avatar
                shape="circle"
                size="xx-small"
                name={authorName}
                src={profileImage}
              />
              <div className={classes.contentContainer}>
                <span
                  className={classNames("text-label", classes.authorName)}
                  data-test-id="reflectionFeedbackModal-authorName"
                >
                  {authorName}
                </span>
                <p
                  className={classNames("text-body", classes.message)}
                  data-test-id="reflectionFeedbackModal-message"
                >
                  {label}
                </p>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className={classes.footer}>
              <Button
                type="outlined"
                variant="neutral"
                onClick={onClose}
                testId="reflectionFeedbackModal-closeButton"
              >
                {t("common:close")}
              </Button>
            </div>
          </Modal.Footer>
        </section>
      </Modal>
    </DSProvider>
  );
};

ReflectionFeedbackModal.propTypes = {
  title: PropTypes.string.isRequired,
  feedback: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    isResolved: PropTypes.bool,
    createdBy: PropTypes.shape({
      id: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      profileImage: PropTypes.string,
    }),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ReflectionFeedbackModal;
